import React from 'react';

export default function About() {
  return <h1>Página About</h1>;
}
